module.exports = __webpack_public_path__ + "img/select-panel-disable.bcb330d1.svg";